export function localeSortBy<T extends { [k: string]: any }>(
  paramName: keyof T,
): (a: T, b: T) => number {
  return (a, b) => a[paramName].localeCompare(b[paramName]);
}
